// extracted by mini-css-extract-plugin
export default {"defaultCheckoutWrapper":"IneD_P","newUiDisclaimer":"bh9fNx","newUi":"LUy8jT","checkoutWrapper":"lUz52I"};